<template>
  <v-container fluid>
    <v-dialog v-model="disconnectAppDialog" width="400">
      <v-card v-if="appToDisconnect" class="border-radius-standard">
        <v-card-title class="headline" primary-title>
          Disconnect {{ appToDisconnect.name }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to disconnect this App?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="black" outline @click="disconnectAppDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading="loaders.disconnect"
            color="error"
            @click="disconnectApp()"
          >
            Disconnect
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="AppsFormDialog" width="500" @close="appToEdit = null">
      <v-card class="border-radius-standard">
        <v-card-title>
          <h2>
            {{ appToEdit ? `Edit ${appToEdit.name}` : "Add WhatsApp App" }}
          </h2>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 400px; overflow-y: auto">
          <add-whatsapp-app
            ref="addApp"
            :put="appToEdit"
            @loading="loaders.add = $event"
            @success="handleAddAppSuccess"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="AppsFormDialog = false"> Cancel </v-btn>
          <v-btn
            disabled
            :loading="loaders.add"
            color="primary"
            @click="handleAddAppSubmit()"
          >
            {{ appToEdit ? "Save" : "Create" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>WhatsApp Numbers</h1>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="card-curvey">
          <v-layout
            wrap
            style="
              display: flex !important;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div>
              <embeddedSignup
                :extras="{
                  buttonText: 'Add WhatsApp Number',
                  type: 'whatsapp',
                }"
                @loginSuccess="addWhatsAppAccount"
                @WA_EMBEDDED_SIGNUP_FINISH="WAEmbeddedSignupFinish"
              ></embeddedSignup>
            </div>
          </v-layout>
          <v-card-text>
            <v-data-table
              :items="whatsappApps"
              :headers="headers"
              :loading="loaders.apps"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.phone_number }}</td>
                <td>{{ props.item.tier_limit }}</td>
                <td :class="setTextColor(props.item.status)">
                  {{ props.item.status.toUpperCase() }}
                </td>

                <td class="actions-col">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        disabled
                        v-on="on"
                        class="px-3 campaigns-small-actions-btn"
                        @click="handleEditApp(props.item)"
                      >
                        <v-icon class="px-3 campaigns-small-actions-btn">
                          edit
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AddWhatsappApp from "./dialogs/addWhatsappApp.vue";
import embeddedSignup from "./embeddedSignup";
export default {
  name: "WhatsappApps",
  components: { AddWhatsappApp, embeddedSignup },
  data() {
    return {
      headers: [
        { text: "Name", value: "name", align: "left" },
        { text: "Number", value: "phone_number", align: "left" },
        { text: "Tier Limit", value: "tier_limit", align: "left" },
        { text: "Status", value: "status", align: "left" },
        { text: "Actions", value: "_id", align: "right" },
      ],
      bot_whatsapp_provider: "",
      AppsFormDialog: false,
      appToDisconnect: null,
      disconnectAppDialog: false,
      appToEdit: null,
      loaders: {
        add: false,
        apps: false,
        disconnect: false,
      },
      signUpData: {
        phone_number_id: null,
        waba_id: null,
        code: null,
      },
    };
  },
  async mounted() {
    await this.init();
    if (this.$route.query.cb && this.$route.query.cb === "add") {
      this.handleAddAppClick();
    }
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
    whatsappApps() {
      return this.$store.state.settings.whatsappAccounts;
    },
  },
  methods: {
    async init() {
      await this.getWhatsAppAccounts();
    },
    async getWhatsAppAccounts() {
      await this.$store.dispatch("getWhatsAppAccounts");
    },

    handleAddAppClick() {
      this.appToEdit = null;
      this.AppsFormDialog = true;
    },
    handleAddAppSubmit() {
      if (this.$refs.addApp) {
        this.$refs.addApp.submit();
      }
    },
    handleDisconnectAppClick(app) {
      this.appToDisconnect = app;
      this.disconnectAppDialog = true;
    },
    async handleAddAppSuccess() {
      this.AppsFormDialog = false;
      this.appToEdit = null;
      await this.init();
    },
    handleEditApp(item) {
      this.appToEdit = item;
      this.AppsFormDialog = true;
    },

    setTextColor(value) {
      let classes = [];
      switch (value.toLowerCase()) {
        case "connected":
        case "green":
          classes.push("green--text");
          break;
        case "disconnected":
          classes.push("red--text");
          break;
      }
      return classes;
    },
    async addWhatsAppAccount(e) {
      await this.$store.dispatch(`addWhatsAppAccountByEmbeddedSignup`, {
        code: e,
        phone_number_id: this.signUpData.phone_number_id,
        waba_id: this.signUpData.waba_id,
      });
    },
    WAEmbeddedSignupFinish(e) {
      this.signUpData.phone_number_id = e.phone_number_id;
      this.signUpData.waba_id = e.waba_id;
    },
  },
};
</script>
<style lang="scss">
.campaigns-small-actions-btn {
  height: 24px;
  width: 24px;
  max-width: 24px;
  min-width: 24px;
  border-radius: 3px !important;
  margin-left: 2px;
}
.campain-small-action-icon {
  font-size: 16px !important;
  margin-left: 4px;
  color: #7f7f7f !important;
}
.campain-small-action-bot-icon {
  font-size: 16px !important;
}
.actions-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 0 !important;
}
</style>
